import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useBreakpoint from "../../hooks/useBreakpoint";
import { useTranslation } from "react-i18next";
import LoadingTextBody from "../atoms/LoadingTextBody";

interface AskAiResponseDialogProps {
  open: boolean;
  isDialogLoading: boolean;
  onClose: () => any;
  response: string;
}

export default function AskAiResponseDialog(props: AskAiResponseDialogProps) {
  const { t } = useTranslation("AskAiResponseDialog");
  const breakpoint = useBreakpoint();
  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.isDialogLoading ? undefined : props.onClose}
      >
        <DialogTitle>{t("AIResponse")}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.isDialogLoading ? undefined : props.onClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText minWidth={breakpoint.md ? 550 : 300}>
            {props.isDialogLoading ? (
              <LoadingTextBody />
            ) : props.response ? (
              props.response
            ) : (
              <></>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
